// useGetQuotes
import { useApi } from 'hooks';
import api from 'lib/quoteBind/quoteBind.api';

async function getRiskQuotes(params, token) {
  const { id, refresh } = params;
  if (!id) {
    throw new Error('useGetQuotes: id is required');
  }

  const apiUrl = refresh ? `risks/${id}/quotes?refresh=true` : `risks/${id}/quotes`;

  const response = await api(token).get(apiUrl);
  return response.data;
}

export function useGetQuotes(queryKey, params, options) {
  return useApi([queryKey, params], async (params, token) => await getRiskQuotes(params, token), {
    cacheTime: 3 * 60 * 1000,
    ...options,
  });
}
